module.exports = __webpack_public_path__ + "static/media/BlueStar.c399e3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/BlueStar.png
// module id = 5755
// module chunks = 0